// extracted by mini-css-extract-plugin
export default {"currentTime":"CurrentTime_currentTime__2k4fX"};